export default __webpack_public_path__ + "static/media/patientGirl.8eb7cdd6.svg";